import { IconDeviceMobile, IconMail, IconUserCircle } from '@tabler/icons-react'

import { Text } from './BUI/Text'
import { Flexbox } from './Flexbox'

import { ProjectContact } from '@/modules/projects/ProjectContactsField'
import { getProjectContactRole } from '@/utils/index'

import { buildPassTheme } from 'src/styles/theme'

import { ContactType } from 'types/api.graphql'

type Contact = {
  name?: string
  email?: string
  number?: string
  type: ContactType
  customType?: string
}

export const ContactCard = ({
  contact,
  showMobile,
}: {
  contact: Partial<Contact>
  showMobile: boolean
}) => (
  <Flexbox flexDirection="column" gap="0.375rem">
    {contact.type && (
      <Flexbox alignItems="center" gap="0.375rem">
        <IconUserCircle
          size={16}
          color={buildPassTheme.colour.secondary._300}
        />
        <Text variant="caption01" secondary="_400">
          {getProjectContactRole(contact as ProjectContact)}
        </Text>
      </Flexbox>
    )}

    {contact.name?.length > 0 && (
      <Text block secondary="base">
        {contact.name}
      </Text>
    )}
    {contact.email && (
      <Flexbox flex="inline-flex" alignItems="center" gap="0.5rem">
        <IconMail size={14} color={buildPassTheme.colour.secondary._300} />
        <Text link variant="caption01">
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </Text>
      </Flexbox>
    )}
    {contact.number && showMobile && (
      <Flexbox flex="inline-flex" alignItems="center" gap="0.5rem">
        <IconDeviceMobile
          size={14}
          color={buildPassTheme.colour.secondary._300}
        />
        <Text link variant="caption01">
          <a href={`tel:${contact.number}`}>{contact.number}</a>
        </Text>
      </Flexbox>
    )}
  </Flexbox>
)
